// http://jasonwatmore.com/post/2017/12/07/react-redux-jwt-authentication-tutorial-example
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import { store } from './_helpers';
import { App } from './App';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/index.css';
// import App from './Components/App'; delete this
import registerServiceWorker from './registerServiceWorker';

render(
  (<Provider store={store}>
    <App />
  </Provider>)
  , document.getElementById('app'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js